export const shallowCompare = (obj1, obj2, excludeKeys = []) => {
    const keys1 = Object.keys(obj1).filter((key) => !excludeKeys.includes(key));
    const keys2 = Object.keys(obj2).filter((key) => !excludeKeys.includes(key));
    return keys1.length === keys2.length && keys1.every((key) => obj1[key] === obj2[key]);
};
//# sourceMappingURL=compare.js.map